define.alias("shared/components/shared/wizard/slide/body", "calendar/components/shared/wizard/slide/body");